import { PILE_CODES, type PileCode } from '../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../formCheckClasses'

interface Props {
  isView: boolean
  selectedPileSize: PileCode | ''
  setSelectedPileSize: (code: PileCode | '') => void
}

const ProductPileSection: React.FC<Props> = ({ isView, selectedPileSize, setSelectedPileSize }) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>งานด้านสินค้า</div>
        </div>
        <div className='card-body'>
          <div className='fw-bold mb-4'>เปิดใช้งานเสาเข็มขนาด</div>
          <div className='d-flex flex-wrap align-items-center gap-5'>
            {PILE_CODES.map(code => (
              <div key={code} className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-pile-size'
                  id={`won-pile-size-${code}`}
                  checked={selectedPileSize === code}
                  disabled={isView}
                  onChange={() => setSelectedPileSize(code)}
                />
                <label className={wonFormCheckLabel} htmlFor={`won-pile-size-${code}`}>
                  {code}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductPileSection
